module.exports = __webpack_public_path__ + "img/admin2.441ddf57.png";